import { SpinnerOverlay } from '@sixfold/common-ui';
import React, { Suspense } from 'react';
import { Route, Routes as Switch } from 'react-router';

import { ErrorType, ErrorView } from './components/error_view';
import { CompanyPickerContainer } from './containers/company_picker';
import { EmailUnsubscribe } from './containers/email_unsubscribe';
import { ExpiredInvite } from './containers/expired_invite';
import { Invite } from './containers/invite';
import { LandingPage } from './containers/landing_page';
import { LoginPage } from './containers/login';
import { RedirectContainer } from './containers/redirect';
import { SharedViewInvitationLoginContainer } from './containers/shared_view_invitation_login';
import { SharedViewLoginContainer } from './containers/shared_view_login';
import { SharedViewSwitcherContainer } from './containers/shared_view_switcher';
import { TokenContainer } from './containers/token';
import { TransporeonSignup } from './containers/transporeon_signup';
import { UnsupportedBrowserPage } from './containers/unsupported-browser';
import { WithdrawnInvite } from './containers/withdrawn_invite';
import * as Routes from './lib/routes';
import './app_router.module.css';

export const AppRouter: React.FC = () => {
  return (
    <Switch>
      <Route
        path={Routes.TransporeonSignupPreAcceptPage.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <TransporeonSignup />
          </Suspense>
        }
      />
      <Route
        path={Routes.Redirect.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <RedirectContainer />
          </Suspense>
        }
      />
      <Route
        path={Routes.Token.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <TokenContainer />
          </Suspense>
        }
      />
      <Route
        path={Routes.SharedViewLogin.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <SharedViewLoginContainer />
          </Suspense>
        }
      />
      <Route
        path={Routes.SharedViewInvitationLogin.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <SharedViewInvitationLoginContainer />
          </Suspense>
        }
      />
      <Route
        path={Routes.PlatformInvite.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <Invite />
          </Suspense>
        }
      />
      <Route
        path={Routes.CompanyPickerPage.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <CompanyPickerContainer />
          </Suspense>
        }
      />
      <Route
        path={Routes.SharedViewSwitcher.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <SharedViewSwitcherContainer />
          </Suspense>
        }
      />
      <Route
        path={Routes.LandingPage.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <LandingPage />
          </Suspense>
        }
      />
      <Route
        path={Routes.LoginPage.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <LoginPage />
          </Suspense>
        }
      />
      <Route
        path={Routes.EmailUnsubscribe.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <EmailUnsubscribe />
          </Suspense>
        }
      />
      <Route
        path={Routes.WithdrawnInvite.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <WithdrawnInvite />
          </Suspense>
        }
      />
      <Route
        path={Routes.ExpiredInvite.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <ExpiredInvite />
          </Suspense>
        }
      />
      <Route
        path={Routes.UnsupportedBrowser.routerPath}
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <UnsupportedBrowserPage />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <Suspense fallback={<SpinnerOverlay />}>
            <ErrorView error={{ type: ErrorType.PAGE_NOT_FOUND }} />
          </Suspense>
        }
      />
    </Switch>
  );
};
